import React from "react";
import { Autocomplete, Box, Button, ListItem, MenuItem, TextField } from "@mui/material";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { useAuth } from "../../../../../auth/auth";
import { updateUserCompetency } from "../../../../../api/apiCall";
import { toast } from "react-toastify";

const EditCompetency = ({
    profileInfo,
    id,
    competencies,
    selectedCompetency,
    setSelectedCompetency,
    expDate,
    setExpDate,
    status,
    setStatus,
    setIsModalEditCompetencyOpen,
    getCompetencies,
}: any) => {
    const {state} = useAuth();

    const editCompetency = async () => {
        console.log(expDate)
        const response = await updateUserCompetency(state.user?.token, {
            userCompetencyId: id,
            expDate: expDate?.format("YYYY-MM-DD"),
            status: status,
        });
        if(response) {
            setIsModalEditCompetencyOpen(false);
            toast.success('Competency edited successfully');
            getCompetencies();
        }
    }

    return (
        <Box display="grid" gridTemplateColumns={{xs: "1fr", md: "1fr"}} gap={3} mt={1}>
            <Autocomplete
                size="small"
                disabled
                options={competencies}
                value={competencies.find((competency: any) => competency.id === selectedCompetency) || selectedCompetency}
                onChange={(_, newValue) => {
                    setSelectedCompetency(newValue)
                }}
                getOptionLabel={(option: any) => option.competencyName}
                renderOption={(props, option) => (
                    <ListItem {...props} key={option.competencyName}>
                      {option.competencyName}
                    </ListItem>
                )}
                renderInput={(params) => (
                    <TextField {...params} label="Competency" placeholder="Select Competency" />
                )}
            />
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DatePicker']}>
                    <DatePicker
                        slotProps={{ textField: { size: 'small', fullWidth: true } }}
                        label="Expiration Date"
                        format="DD/MM/YYYY"
                        value={expDate ? dayjs(expDate) : null}
                        onChange={(value) => {
                            setExpDate(value ? value.toISOString() : null);
                        }}
                    />
                </DemoContainer>
            </LocalizationProvider>
            <TextField
                select
                value={status}
                id="demo-select-small"
                size="small"
                label="Status"
                sx={{mb: 2}}
                onChange={(e: any) => {setStatus(e.target.value)}}
            >
                <MenuItem value={0}>Pending</MenuItem>
                <MenuItem value={1}>Approved</MenuItem>
                <MenuItem value={2}>Denied</MenuItem>
                <MenuItem value={3}>Not Verified</MenuItem>
            </TextField>
            <div className="center-button-div">
                <Button variant="contained" sx={{boxShadow: 'none'}} onClick={editCompetency}>
                    Edit Competency
                </Button>
            </div>
        </Box>
    )
}

export default EditCompetency;
